@if((shouldShowLoading$ | async) && (service.loading$ | async)) {
  <div class="loading-overlay" role="status" aria-live="polite">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
}


